// Hotfix 25-oct-2026: Dropi retiro GUADALUPE (Zacatecas) de contra entrega.
// Verificado en Dropi Crear Orden (el desplegable de municipios ya no lo ofrece)
// y con los pedidos de prueba HS-1232/HS-1233 rechazados por Dropify con
// "La ciudad no tiene habilitado el metodo de envio: CON RECAUDO".
// Este script elimina Guadalupe ZAC del formulario DESPUES de cargar la cobertura.
// Si Dropi lo restaura: borrar la linea del script en layout/theme.liquid y este archivo.
(function () {
  try {
    if (window._CUSTOM_COD_FORM_PROVINCES && _CUSTOM_COD_FORM_PROVINCES.data && _CUSTOM_COD_FORM_PROVINCES.data.ZACATECAS) {
      delete _CUSTOM_COD_FORM_PROVINCES.data.ZACATECAS.GUADALUPE;
    }
  } catch (e) {}
})();
